import type { PropsWithChildren } from "react";

export function Panel({ children }: PropsWithChildren) {
  return (
    <section className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 shadow-2xl shadow-slate-950/20">
      {children}
    </section>
  );
}
